import { getAuth } from "firebase/auth";
import { useEffect } from "react";

const LogoutPage = () => {
  const auth = getAuth();
  useEffect(() => {
    auth.signOut();
  }, []);
  return null;
};
export default LogoutPage;
